import MainContainer from "./mainContainer";

function App() {
 return <MainContainer></MainContainer>
}

export default App;